module.exports = __webpack_public_path__ + "static/logo.19c9d377.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 610
// module chunks = 168707334958949